import { defineMessages } from "@/i18n";
import en from "./en";

export const weatherFrameMessages = defineMessages("frames-weather", en);
